// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import cookies from './utils/jscookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BackTop from '@/utils/BackTop'
import { WOW } from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
import './assets/css/font.css'
import ch from './language/ch'
import en from './language/en'
import fr from './language/fr'
//这里需要将样式用起来，
Vue.use(animated)
Vue.use(VueI18n)

const cookieLang = cookies.getCookie("language");
const lang = cookieLang == null?'zh':cookieLang;
const i18n = new VueI18n({
  locale: lang,
  messages:{
    'ch':ch,
    'en':en,
    'fr':fr
  }
})

//创建全局实例
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 需要执行动画的元素的 class
  animateClass: 'animated', //animation.css 动画的 class
  offset: 0, // 距离可视区域多少开始执行动画
  mobile: true, // 是否在移动设备上执行动画
  live: true, // 异步加载的内容是否有效
  callback: null,
  scrollContainer: null
})
// 全局方法
Vue.prototype.$cookies = cookies
Vue.prototype.$store = store
Vue.prototype.$BackTop = BackTop


Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  i18n,
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js